import React, { useState, useEffect, useLayoutEffect } from 'react';
import { Alert, ErrorScreen } from 'components/common';
import { useDocument, useUser } from 'components/hooks';
import { formatProjectItems } from 'helpers';
import withRequest from 'hoc/withRequest';
import { withRouter } from 'react-router-dom';
import { CircularProgress, Backdrop } from '@mui/material';
import DocumentViewDumb from './DocumentViewDumb';


const DocumentViewSmart = (props) => {
  const { match: { params } } = props;
  const { document, baseUrl } = params;
  const { parameters } = useUser();
  const projects = formatProjectItems(parameters);

  const { cleanUpMessage, error, success, getDocument, data, isLoaded } = useDocument();

  const [defaultValues, setDefaultValues] = useState({
    name: '',
    document: ''
  });

  useEffect(() => {
    if (!!success.get) handleData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success.get]);

  useLayoutEffect(() => {
    const query = {
      baseUrl: baseUrl,
      document: document
    }
    getDocument({ query });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCloseAlert = () => cleanUpMessage();

  function handleData() {
    const dataToSet = {
      name: document,
      document: data
    }
    setDefaultValues(dataToSet);
  };

  return (
    <>
      { error.get ?
        (
          <ErrorScreen />
        ): isLoaded.get ?
        (
          <Backdrop
            invisible
            sx={{ zIndex: (theme) => theme.zIndex.drawer - 1 }}
            open={true}
          >
            <CircularProgress color="primary" />
          </Backdrop>
        ): (data && projects) ?
        (
          <DocumentViewDumb
            defaultValues={defaultValues}
            viewingDocument={document}
            isEdit={true}
          />
        )
        :(
          <ErrorScreen />
        )
      }
      <Alert severity="error" handleClose={handleCloseAlert} open={error.put} message="common.errors.general.title" />
    </>
  );
};

export default withRequest(withRouter(DocumentViewSmart));
